export const messages = {
    en: {
      aInspectionPlanDetail: {
        title: 'Inspection Plan',
        planName: 'Plan Name',
        planRoute: 'Plan Route',
        planPeriod: 'Plan Period',
        signType: 'Sign Type',
        dateRange: 'Date Range',
        timeRange: 'Time Range',
        taskAdvance: 'Task Advance(min)',
        creator: 'Creator',
        createTime: 'Create Time',
        status: 'Status',
        staff: 'Staff',
        route: 'Route',
        point: 'Point',
        task: 'Task',
        detail: 'Detail',
        staffName: 'Staff Name',
        startTime: 'Start Time',
        endTime: 'End Time',
        pointId: 'Point ID',
        pointName: 'Point Name',
        pointType: 'Point Type',
        pointLocation: 'Point Location',
        sort: 'Sort',
        detailId: 'Detail ID',
        staffTime: 'Staff Time',
        pointTime: 'Point Time',
        actualTime: 'Actual Time',
        signStatus: 'Sign Status',
        planStaff: 'Plan Staff',
        actualStaff: 'Actual Staff',
        taskStatus: 'Task Status',
        pointStatus: 'Point Status',
        inspectionResult: 'Inspection Result',
        photos: 'Photos',
        // 新增字段
        inspectionMethod: 'Inspection Method',
        taskState: 'Task State',
        pointState: 'Point State',
        createUser: 'Create User',
        inspectionPhotos: 'Inspection Photos'
      }
    },
    zh: {
      aInspectionPlanDetail: {
        title: '巡检计划',
        planName: '计划名称',
        planRoute: '计划路线',
        planPeriod: '计划周期',
        signType: '签到方式',
        dateRange: '日期范围',
        timeRange: '时间范围',
        taskAdvance: '任务提前(分钟)',
        creator: '制定人',
        createTime: '制定时间',
        status: '状态',
        staff: '巡检人员',
        route: '巡检路线',
        point: '巡检点',
        task: '巡检任务',
        detail: '巡检明细',
        staffName: '巡检人员',
        startTime: '开始时间',
        endTime: '结束时间',
        pointId: '巡检点ID',
        pointName: '巡检点名称',
        pointType: '巡检点类型',
        pointLocation: '巡检位置',
        sort: '排序',
        detailId: '任务详情ID',
        staffTime: '巡检人时间',
        pointTime: '巡检点时间',
        actualTime: '实际巡检时间',
        signStatus: '实际签到状态',
        planStaff: '计划巡检人',
        actualStaff: '实际巡检人',
        taskStatus: '任务状态',
        pointStatus: '巡检点状态',
        inspectionResult: '巡检情况',
        photos: '巡检照片',
        // 新增字段
        inspectionMethod: '巡检方式',
        taskState: '任务状态',
        pointState: '巡检点状态',
        createUser: '创建人',
inspectionPhotos: '巡检照片'
      }
    },
    'zh-TW': {
      aInspectionPlanDetail: {
        title: '巡檢計劃',
        planName: '計劃名稱',
        planRoute: '計劃路線',
        planPeriod: '計劃週期',
        signType: '簽到方式',
        dateRange: '日期範圍',
        timeRange: '時間範圍',
        taskAdvance: '任務提前(分鐘)',
        creator: '制定人',
        createTime: '制定時間',
        status: '狀態',
        staff: '巡檢人員',
        route: '巡檢路線',
        point: '巡檢點',
        task: '巡檢任務',
        detail: '巡檢明細',
        staffName: '巡檢人員',
        startTime: '開始時間',
        endTime: '結束時間',
        pointId: '巡檢點ID',
        pointName: '巡檢點名稱',
        pointType: '巡檢點類型',
        pointLocation: '巡檢位置',
        sort: '排序',
        detailId: '任務詳情ID',
        staffTime: '巡檢人時間',
        pointTime: '巡檢點時間',
        actualTime: '實際巡檢時間',
        signStatus: '實際簽到狀態',
        planStaff: '計劃巡檢人',
        actualStaff: '實際巡檢人',
        taskStatus: '任務狀態',
        pointStatus: '巡檢點狀態',
        inspectionResult: '巡檢情況',
        photos: '巡檢照片',
        inspectionMethod: '巡檢方式',
        taskState: '任務狀態',
        pointState: '巡檢點狀態',
        createUser: '創建人',
        inspectionPhotos: '巡檢照片'
      }
    }
  }